import React from 'react'
import { settings as typography } from './typography'
import { settings as space } from './spacing'
import { settings as colors } from './colors'
import { settings as breakpoints } from './breakpoints'
import { settings as borders } from './borders'
import { settings as alignments } from './alignments'

export type StyledProps = {
  as?: React.ElementType | keyof JSX.IntrinsicElements
}

export type Theme = typeof defaultTheme

export const defaultTheme = {
  ...colors,
  ...breakpoints,
  ...space,
  ...typography,
  ...borders,
  ...alignments,
} as const
